import { api } from '../../DefaultService';
import {
  IResponsibleRecognitionEventProps,
  IResponsibleRecognitionEventSimpleProps,
} from './types';
import { IPaginationParams } from '../../types';

export const ENDPOINT_RESPONSIBLE = 'v1/events/recognitionResponsible';

export const getResponsibleRecognitionEventByIdAsync = async (
  id: number,
): Promise<IResponsibleRecognitionEventProps> => {
  return await api
    .get(`${ENDPOINT_RESPONSIBLE}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllResponsibleRecognitionEventByLicenseAsync = async (
  params: IPaginationParams,
): Promise<IResponsibleRecognitionEventSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT_RESPONSIBLE}/getAllByLicense`, {
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllResponsibleRecognitionEventCountByLicenseAsync =
  async (): Promise<number> => {
    return await api
      .get(`${ENDPOINT_RESPONSIBLE}/getAllByLicense/count`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  };
